export default class Count {
	constructor({ elements }) {
		const speed = 500;
		elements.forEach((el) => {
			const updateCount = () => {
				const targetCount = +el.getAttribute('data-target-count');
				const count = +el.innerText;
				const inc = targetCount / speed;
				const element = el;
				if (count < targetCount && !Number.isNaN(inc) && !Number.isNaN(count)) {
					element.innerText = Math.ceil(count + inc);
					setTimeout(updateCount, 1);
				}
			};
			updateCount();
		});
	}
}
